module.exports = __webpack_public_path__ + "img/otp_sync_new.0e90a01c.png";